import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-opciones-exportar',
  templateUrl: './opciones-exportar.component.html',
  styleUrls: ['./opciones-exportar.component.scss'],
})
export class OpcionesExportarComponent implements OnInit {

  constructor(public popover: PopoverController, private utilidades: UtilidadesService) { }

  ngOnInit() {
    setTimeout(() => {
      this.utilidades.Loading("")
    }, 100);
    setTimeout(() => {
      // Quitar esta opción cuando hayan mas opciones de exportacion
      setTimeout(() => {
        this.utilidades.CerrarLoading()
      }, 100);
      this.popover.dismiss('pdf')
    }, 500);
  }



}
